/** @file Ends a running mix preview so the viewport poses from the playhead or setup again. */
import { mixPreviewStore } from '../../playback/mixPreviewStore';

/** True when a run was stopped: a tool press and a Setup/Animate switch never edit over the mixed pose (R-E1-04). */
export function stopMixPreview(): boolean {
  if (mixPreviewStore.getState().run === null) return false;
  mixPreviewStore.setState({ run: null });
  return true;
}
